// extracted by mini-css-extract-plugin
module.exports = {"base_info":"dece2e673c--base_info--190PA","price_info":"dece2e673c--price_info--u-FQr"};